// Both events need a GTM tag (Custom Event trigger + GA4 tag in
// GTM-MRTF5WC) before they reach GA4 — untagged dataLayer pushes drop
// silently; the Vercel mirror needs no setup. Full spec + GTM checklist:
// docs/feature-ae-delivery-eta-analytics.md.
// SHOWN fires at most once per mount (a re-mount, e.g. after a client-side
// nav back to the buy page, fires again) and carries an `emirate` payload
// field; EMIRATE_SELECTED fires on every <select> change.
export const AE_DELIVERY_GTM_EVENTS = {
  SHOWN: 'aeDeliveryEtaShown',
  EMIRATE_SELECTED: 'aeDeliveryEmirateSelected',
} as const;

/** sessionStorage key for the chosen emirate (per-tab, mirrors
 * SDD_PINCODE_STORAGE_KEY in ../DeliveryEtaBadge/config.ts). Written by
 * RingSelectionContext's setSelectedEmirate, restored in an effect there. */
export const AE_EMIRATE_STORAGE_KEY = 'uh_ae_emirate';
